import styles from './PaymentButtonsLoader.module.css';

/**
 * Placeholder shown in place of the payment buttons while the entered
 * amount is still being persisted (debounce + request in flight) —
 * payment must stay blocked until the DB holds the latest amount.
 */
const PaymentButtonsLoader = (): React.JSX.Element => (
    <div className={styles.loaderBox}>
        <span className={styles.spinner} />
    </div>
);

export { PaymentButtonsLoader };
